import React from 'react';
import {Card,} from '@mui/material';
import {lighten} from "@mui/material/styles";
import {withStyles} from "@mui/styles";
import MindfileItemView from "../../../pages/explore/items/item-viewer/MindfileItemView";

const styles = (theme) => ({
  items:{
    margin:0,
    padding:0,
    // backgroundColor:"#0000000a"
  },
  itemList: {
    margin:'1em auto',
    display:'flex',
    flexDirection:'column',
    gap:'1.25em',
    maxWidth:"1280px",
  },
  itemCard:{
    // padding:"0.5em",
    borderTop: '1px solid rgba(0,0,0,0.12)'
  },
  highlight: {
    color: theme.palette.secondary.main,
    backgroundColor: lighten(theme.palette.secondary.light, 0.85),
  },
});

function DataStreamView(props) {
  const { itemList, columnMap, selectedItems, onSelectItem, openDataView,
    moveItems, removeItems, saveItems, folderList, addFolder,
    addFilterSelectByName, mindfileFilterValues, mindfileUserLevel, getMindfileItem,
    mindfileDisplay, itemChangeCallback, classes } = props;

  return (
    <div className={classes.items}>
      <div id="dataTableStreamView" className={classes.itemList}>
        {itemList.map((item, index) => {
          const isSelected = !!selectedItems[item.id];
          return (
            <Card key={`stream_${item.id}`} className={isSelected ? `${classes.itemCard} ${classes.highlight}` : classes.itemCard}>
              <MindfileItemView
                item={item}
                columnMap={columnMap}
                initialDisplayType="thumbnail"
                collapsed={true}
                isSelected={isSelected}
                onSelectItem={() => onSelectItem(item)}
                saveItems={saveItems}
                moveItem={moveItems.bind(this, [item.id])}
                removeItem={removeItems.bind(this, [item.id])}
                folderList={folderList}
                addFolder={addFolder}
                mindfileFilterValues={mindfileFilterValues}
                openDataView={openDataView}
                itemChangeCallback={itemChangeCallback}
                showToolbar={mindfileUserLevel <= 2}
                showStatusIcon={true}
                canSelect={mindfileUserLevel <= 2}
                mindfileUserLevel={mindfileUserLevel}
                getMindfileItem={getMindfileItem}
                mindfileDisplay={mindfileDisplay}
                addFilterSelectByName={addFilterSelectByName}
              />
            </Card>
          )
        })}
      </div>
    </div>
    );
}

export default withStyles(styles)(DataStreamView);
